import React, { PropsWithChildren } from 'react'
import { ComponentTitleWrapper } from './style'

export const IsoPageHeader = (props: PropsWithChildren<{}>) => (
  <ComponentTitleWrapper className="isoComponentTitle">
    {props.children}
  </ComponentTitleWrapper>
)
